
import { PageRequest, PageResponse } from "protobuf/page_pb";
import { GetTripSummaryRequest, GetTripSummaryResponse } from "protobuf/user_stats_service_pb";
import { CommonActions, FilterItem, GetState, TripsActions, TripsState } from "types/store";
import { PAGE_SIZE, SUCCESS_MESSAGES } from "utils/constants";
import { Dispatch, ReactNode } from "react";
import { apiResponse } from "./common-actions";
import { UserStatsServiceClient } from "protobuf/User_stats_serviceServiceClientPb";
import {dataTripServiceClient, userStatsServiceClient, vehicleStatsServiceClient} from "utils/grpc-clients";
import {
  GetTripCoordinateRequest,
  GetTripsCountAndTotalKmDrivenRequest,
  GetTripsCountAndTotalKmDrivenResponse,
  GetUserTripsRequest,
  GetUserTripsResponse,
  GetVehicleTripsRequest,
  GetVehicleTripsResponse
} from "protobuf/vehicle_stats_service_pb";
import { VehicleServiceClient } from "protobuf/Vehicle_serviceServiceClientPb";
import { VehicleStatsServiceClient } from "protobuf/Vehicle_stats_serviceServiceClientPb";
import dayjs from "dayjs";
import { getSecondsFromDate, getSecondsFromMillis, getValueArrFromFilterOptions } from "utils/helpers";
import { subDays, subMonths, subWeeks } from "date-fns";
import { Filters } from "protobuf/filter_pb";
import moment from "moment";
import {
  GetTripCoordinateDataResponse,
  GetVehiclesTripsRequest,
  GetVehiclesTripsResponse
} from "../../protobuf/trip_service_pb";
import {TripDataServiceClient} from "../../protobuf/Trip_serviceServiceClientPb";

function getRange(updatedFilters: FilterItem) {
  const selectedOption = updatedFilters["Time Range"][0];
  const currentDate = new Date();
  const exclusiveTime = getSecondsFromDate(currentDate);
  const today = moment().endOf("day");
  const last3Days = {
    inclusive: getSecondsFromDate(subDays(currentDate, 3)),
    exclusive: exclusiveTime,
  };
  const lastWeek = {
    inclusive: getSecondsFromDate(subWeeks(currentDate, 1)),
    exclusive: exclusiveTime,
  };
  const lastMonth = {
    inclusive: getSecondsFromDate(subMonths(currentDate, 1)),
    exclusive: exclusiveTime,
  };
  const defaultValues = {
    inclusive: getSecondsFromDate(new Date(0)),
    exclusive: getSecondsFromMillis(currentDate.getTime()),
  };
  const customRange = selectedOption?.range
    ? {
        inclusive: getSecondsFromDate(selectedOption.range[0]),
        exclusive: getSecondsFromDate(selectedOption.range[1]),
      }
    : defaultValues;

  switch (selectedOption["value"]) {
    case "Last 3 days":
      return last3Days;
    case "Last week":
      return lastWeek;
    case "Last month":
      return lastMonth;
    case "Custom":
      return customRange;
    default:
      return defaultValues;
  }
}

function getDateRangeFromInputs(start_date: string, end_date: string) {
  const isValidStartDate = dayjs(start_date, "YYYY-MM-DD", true).isValid();
  const isValidEndDate = dayjs(end_date, "YYYY-MM-DD", true).isValid();

  if (!isValidStartDate || !isValidEndDate) {
    return null;
  }

  return {
    inclusive: getSecondsFromDate(new Date(`${start_date}T00:00:00`)),
    // End-of-day inclusive on UI -> exclusive timestamp for backend query.
    exclusive: getSecondsFromDate(new Date(`${end_date}T23:59:59`)),
  };
}



  export function initializeTrips({
    pageNo,
    start_date,
    end_date,
    updatedFilters,
    search
  }: {
    pageNo: number;
    start_date: string;
    end_date: string;
    updatedFilters: FilterItem;
    search: string;
  }) {
    return (dispatch: Dispatch<any>, getState: GetState) => {
    // const isValidStartDate = dayjs(start_date, 'YYYY-MM-DD', true).isValid();
    // const isValidEndDate = dayjs(end_date, 'YYYY-MM-DD', true).isValid();
  
    // const validStartDate = isValidStartDate ? start_date : "";
    // const validEndDate = isValidEndDate ? end_date : "";
    // console.log("validStartDate:",validStartDate);
    // console.log("validEndDate:",validEndDate);
      const {userType, organizationId, ownerOrgId, clientOrgId} = getState().common
       const sort = new PageRequest.Sort();
            sort.setField("created_at");
            sort.setOrder(2);
    const page = new PageRequest();
    page.setPageSize(PAGE_SIZE);
    page.setPageNumber(pageNo);
    page.setSort(sort);
   const selectedDateRange = getDateRangeFromInputs(start_date, end_date);
   const range = selectedDateRange || getRange(updatedFilters);
 const clientFilter = new Filters.In();
  const clientValues = getValueArrFromFilterOptions(
    "Client",
    updatedFilters
  );
  clientFilter.setStringsList(clientValues);

    const request = new GetVehiclesTripsRequest();
    request.setPage(page);
    request.setClientIdList(clientValues || [""]);
    if(userType == 5) {
      console.log("organizationId : ", ownerOrgId)
      request.setClientIdList([ownerOrgId || ""]);
    }
    request.setSearchString(search);
    request.setStartDate(Math.round(range.inclusive));
    request.setEndDate(Math.round(range.exclusive));

      function dispatcher(resp: GetVehiclesTripsResponse) {
        dispatch(setTripsList([]))
        const page = resp?.getPage()?.toObject() || {
          totalElements: 0,
          totalPages: 0,
        };
        const tripsList = resp
          ?.getTripsList()
          ?.map((trips) => ({
            id: trips.getId(),
            vehicle_id: trips.getLicensePlate(),
            rider_name: trips.getRiderName(),
            start_time: trips.getStartTime(),
            end_time: trips.getEndTime(),
            total_km: trips.getTotalKm().toString(),
            soc_used: trips.getSocUsed(),
            score: trips.getScore ? trips.getScore().toString() : "0", // Ensure score is always a string
            total_battery: trips.getTotalBattery() || 3,
            raw: trips,
          })) || [];
         
          console.log("tripsList:",tripsList);
          console.log("Page:",page);
        dispatch(setTripsPage(page));
        dispatch(setTripsList(tripsList));
      }
  
      dispatch(
        apiResponse<
          TripDataServiceClient,
          GetVehiclesTripsRequest,
          GetVehiclesTripsResponse
        >({
          client: dataTripServiceClient,
          action: "getVehiclesTrips",
          request,
          dispatcher,
        })
      );
    };
  }


////////////////TRIP COORDINATE////////////////

export function getTripCoordinate({
id,}: {
  id: string;
}) {

  const request = new GetTripCoordinateRequest();
  request.setTripId(id)
  console.log("trip id : ", id)
  return (dispatch: Dispatch<any>) => {
    function dispatcher(resp: GetTripCoordinateDataResponse) {
      const coordinate = resp
          ?.getCoordinatesList()?.map((tripCoordinate) => ({
            lat: tripCoordinate.getLat(),
            lng: tripCoordinate.getLng(),

          })) || [];

      console.log("trip coordinate in api:",coordinate);
      dispatch(setTripCoordinate(coordinate));
    }

    dispatch(
        apiResponse<
            VehicleStatsServiceClient,
            GetTripCoordinateRequest,
            GetTripCoordinateDataResponse
        >({
          client: vehicleStatsServiceClient,
          action: "getTripCoordinate",
          request,
          dispatcher,
        })
    );
  };
}

////////////////////////////////////


  export function riderTrips({
    pageNo,
    user_id,
  }: {
    pageNo: number;
    user_id: string;
  }) {
 
       const sort = new PageRequest.Sort();
            sort.setField("created_at");
            sort.setOrder(2);
    const page = new PageRequest();
    page.setPageSize(PAGE_SIZE);
    page.setPageNumber(pageNo);
    page.setSort(sort);

    const request = new GetUserTripsRequest();
    request.setPage(page);
    request.setUserId(user_id || "");
    return (dispatch: Dispatch<any>) => {
      function dispatcher(resp: GetUserTripsResponse) {
        const page = resp?.getPage()?.toObject() || {
          totalElements: 0,
          totalPages: 0,
        };
        const riderTripsList = resp
          ?.getTripsList()
          ?.map((trips) => ({
            id: trips.getId(),
            vehicle_id: trips.getLicensePlate(),
            rider_name: "",
            start_time: trips.getStartTime(),
            end_time: trips.getEndTime(),
            total_km: trips.getTotalKm().toString(),
            soc_used: trips.getSocUsed(),
            total_battery: trips.getTotalBattery() || 3,
            score: trips.getScore ? trips.getScore().toString() : "0", // Ensure score is always a string
          })) || [];
         
          console.log("Rider tripsList:",riderTripsList);
        dispatch(setRiderTripsPage(page));
        dispatch(setRiderTripsList(riderTripsList));
      }
  
      dispatch(
        apiResponse<
          VehicleStatsServiceClient,
          GetUserTripsRequest,
          GetUserTripsResponse
        >({
          client: vehicleStatsServiceClient,
          action: "getUserTrips",
          request,
          dispatcher,
        })
      );
    };
  }


  export function downloadAllTrips({
    pageElements,
    updatedFilters,
    search,
  }: {
    pageElements: number;
    updatedFilters: FilterItem,
    search: string,
  }) {
    return (dispatch: Dispatch<any>, getState: GetState) => {
      console.log("download trips function called")
      const {userType, organizationId, ownerOrgId, clientOrgId} = getState().common
      const sort = new PageRequest.Sort();
      sort.setField("created_at");
      sort.setOrder(2);
      const page = new PageRequest();
      page.setPageSize(pageElements);
      console.log("pageElements for Download:",pageElements);
      page.setPageNumber(1);
      page.setSort(sort);
     const range = getRange(updatedFilters);
     const clientFilter = new Filters.In();
     const clientValues = getValueArrFromFilterOptions(
        "Client",
        updatedFilters
      );
      clientFilter.setStringsList(clientValues);
      const request = new GetVehiclesTripsRequest();
      request.setPage(page);
      request.setClientIdList(clientValues || [""]);
      if(userType == 5) {
        console.log("organizationId : ", ownerOrgId)
        request.setClientIdList([ownerOrgId || ""]);
      }
      request.setStartDate(Math.round(range.inclusive));
      request.setEndDate(Math.round(range.exclusive));
      request.setSearchString(search);

      function dispatcher(resp: GetVehiclesTripsResponse) {
        const page = resp?.getPage()?.toObject() || {
          totalElements: 0,
          totalPages: 0,
        };
        const tripsList = resp
          ?.getTripsList()
          ?.map((trips) => ({
            id: trips.getId(),
            vehicle_id: trips.getLicensePlate(),
            rider_name: trips.getRiderName(),
            start_time: trips.getStartTime(),
            end_time: trips.getEndTime(),
            total_km: trips.getTotalKm().toString(),
            soc_used: trips.getSocUsed(),
            total_battery: trips.getTotalBattery() || 3,
            score: trips.getScore ? trips.getScore().toString() : "0", // Ensure score is always a string
          })) || [];
         
          console.log("tripsList for Download:",tripsList);
           dispatch(setDownloadTripsList(tripsList));
      }
  
      dispatch(
        apiResponse<
          TripDataServiceClient,
          GetVehiclesTripsRequest,
          GetVehiclesTripsResponse
        >({
          client: dataTripServiceClient,
          action: "getVehiclesTrips",
          request,
          dispatcher,
        })
      );
    };
  }



  export function getTripsCountAndTotalKmDriven({
    client_id,
    start_date,
    end_date,
  }: {
    client_id: string;
    start_date: string;
    end_date: string;
  }) { 
    const isValidStartDate = dayjs(start_date, 'YYYY-MM-DD', true).isValid();
    const isValidEndDate = dayjs(end_date, 'YYYY-MM-DD', true).isValid();
  
    const validStartDate = isValidStartDate ? start_date : dayjs().format('YYYY-MM-DD');
    const validEndDate = isValidEndDate ? end_date : dayjs().format('YYYY-MM-DD');
  
    const request = new GetTripsCountAndTotalKmDrivenRequest();
    request.setClientId(client_id || "");
    request.setStartDate(validStartDate || "");
    request.setEndDate(validEndDate || "");
    return async (dispatch: Dispatch<any>) => {
      function dispatcher(resp: GetTripsCountAndTotalKmDrivenResponse ) {
        const totalKmDriven = resp.getTotalKmDriven();
        const totalTrips = resp.getTotalTrips();
          console.log("totalKmDriven:",totalKmDriven);
          console.log("totalTrips:",totalTrips);
        dispatch(setTotalTrips(totalTrips));
        dispatch(setTotalKms(totalKmDriven));
      }
  
      dispatch(
        apiResponse<
          VehicleStatsServiceClient,
          GetTripsCountAndTotalKmDrivenRequest,
          GetTripsCountAndTotalKmDrivenResponse
        >({
          client: vehicleStatsServiceClient,
          action: "getTripsCountAndTotalKmDriven",
          request,
          dispatcher,
        })
      );
    };
  }
  
  export function onChangeTripsFilters(
    name: string,
    value: string[],
    type: "all" | "list"
  ) {
    return (
      dispatch: Dispatch<TripsActions | CommonActions>,
      getState: GetState
    ) => {
      const {
        trips: {
          filters: { original, updated },
        },
      } = getState();
      if (type === "list") {
        const filteredValues = original[name].filter((filter) =>
          value.includes(filter.value)
        );
        const updatedFilters = { ...updated, [name]: filteredValues };
        console.log("Updated filter: ",updatedFilters)
        dispatch(updateTripsFilters(updatedFilters));
      } else {
        const updatedFilters = {
          ...updated,
          [name]: value ? original[name] : [],
        };
        dispatch(updateTripsFilters(updatedFilters));
      }
    };
  }
  
export function onChangeRootTripsFilters(checked?: boolean) {
  return (
    dispatch: Dispatch<TripsActions | CommonActions>,
    getState: GetState
  ) => {
    const {
      trips: {
        filters: { original, updated },
      },
    } = getState();

    let updateFilters = {};

    if (checked) {
      updateFilters = {
        ...updated,
        Client: original["Client"],
      };
    } else {
      updateFilters = {
        ...updated,
        "Time Range": [{ label: "Last month", value: "Last month" }],
        Client: [],
      };
    }

    dispatch(updateTripsFilters(updateFilters));
  };
}

  export function setClientFilters(clients: TripsState["clients"]) {
    return (dispatch: Dispatch<TripsActions>, getState: GetState) => {
      const { original } = getState().trips.filters;
      const clientsFilters =
        clients?.map((client) => ({
          label: client.name,
          value: client.id,
        })) || [];
  
      dispatch(settOriginalFilters({ ...original, Client: clientsFilters }));
    };
  } 
  
export function onChangeTimeRangeTripsFilters(
  value: string,
  range?: [Date, Date]
) {
  return (
    dispatch: Dispatch<TripsActions | CommonActions>,
    getState: GetState
  ) => {
    const {
      trips: {
        filters: { original, updated },
      },
    } = getState();
    const selectedTime = original["Time Range"]?.find(
      (option) => option.value === value
    );
    const updateFilters = {
      ...updated,
      "Time Range": selectedTime ? [{ ...selectedTime, range }] : [],
    };

    dispatch(updateTripsFilters(updateFilters));
  };
}

export function setTripsPage(
  payload: PageResponse.AsObject
): TripsActions {
  return {
    type: "SET_TRIP_TOTAL_PAGE",
    payload,
  };
}

export function setRiderTripsPage(
  payload: PageResponse.AsObject
): TripsActions {
  return {
    type: "SET_RIDER_TRIP_TOTAL_PAGE",
    payload,
  };
}
export function setTripsSelectedPage(payload: number): TripsActions {
  return {
    type: "SET_TRIP_SELECTED_PAGE",
    payload,
  };
}

export function setRiderTripsSelectedPage(payload: number): TripsActions {
  return {
    type: "SET_RIDER_TRIP_SELECTED_PAGE",
    payload,
  };
}

export function setTripsSearch(
    payload: TripsState["search"]
): TripsActions {
    return {
        type: "SET_TRIPS_SEARCH",
        payload,
    };
}

export function updateTripsFilters(
  payload: TripsState["filters"]["updated"]
): TripsActions {
  return {
    type: "SET_TRIPS_UPDATED_FILTERS",
    payload,
  };
}

export function settOriginalFilters(
  payload: TripsState["filters"]["original"]
): TripsActions {
  return {
    type: "SET_TRIPS_ORIGINAL_FILTERS",
    payload,
  };
}



export function setTripsList(payload: { id:string, vehicle_id: string; rider_name: string; start_time: string; end_time: string; total_km: string; soc_used: string; total_battery:number; score: string; }[]): TripsActions {
  return {
    type: "SET_TRIPS_TABLE",
    payload,
  };
}

export function setRiderTripsList(payload: { id:string, vehicle_id: string; rider_name: string; start_time: string; end_time: string; total_km: string; soc_used: string; total_battery:number; score: string; }[]): TripsActions {
  return {
    type: "SET_RIDER_TRIPS_TABLE",
    payload,
  };
}


export function setDownloadTripsList(payload: { id:string, vehicle_id: string; rider_name: string; start_time: string; end_time: string; total_km: string; soc_used:  string; total_battery:number; score: string; }[]): TripsActions {
  return {
    type: "SET_DOWNLOAD_TRIPS_TABLE",
    payload,
  };
}

export function setTripCoordinate(payload:TripsState["tripCoordinate"]) : TripsActions {
  return {
    type: "SET_TRIP_COORDINATE",
    payload,
  };
}

export function setTotalTrips(payload: number): TripsActions {
  return {
    type: "SET_TOTAL_TRIPS",
    payload,
  };
}


export function setTotalKms(payload: number): TripsActions {
  return {
    type: "SET_TOTAL_KMS",
    payload,
  };
}

function getFilterState(data: FilterItem, type: "full" | "empty" = "full") {
  if (type === "empty") {
    const emptyObj: any = {};
    Object.keys(data).forEach((filterName) => {
      emptyObj[filterName] = [];
    });
    return emptyObj as FilterItem;
  }

  return data;
}